import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { fetchInputFiles } from "../api/fetchJobResults";
import { JOB_RESULTS_REFRESH_MS } from "../model/constants";

export const useTransientJobInputs = (configId?: number, shouldRefresh = false) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const enabled = Boolean(projectId) && configId != null;
  const query = useQuery(
    ["transientJobInputs", projectId, configId],
    () => {
      if (!projectId || configId == null) throw new Error("Missing project");
      return fetchInputFiles(projectId, configId);
    },
    {
      cacheTime: shouldRefresh ? 0 : 30 * 60 * 1000,
      enabled,
      refetchInterval: shouldRefresh ? JOB_RESULTS_REFRESH_MS : false,
      refetchOnMount: shouldRefresh,
      refetchOnWindowFocus: shouldRefresh,
      staleTime: shouldRefresh ? 0 : Infinity,
    }
  );

  return {
    error: query.isError ? t("Execution.transient.jobDetails.inputsFailed") : null,
    files: query.data ?? [],
    isLoading: enabled && query.isLoading,
  };
};
